export default __webpack_public_path__ + "static/media/YoutubeSVG.9b437d26.svg";